import { FC } from 'react';

const NoMatch: FC = () => (
  <>
    No match
  </>
);

export default NoMatch;
